import styled from 'styled-components';
import { ArrowLeftIcon } from 'styles/components';
import { Mail } from 'lucide-react';

export const MainPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  padding: 24px 32px;
  gap: 20px;
  background: #fff;
  min-height: 0;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  h1 {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 20px;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentModal = styled.div`
  width: 100%;
`;

export const BorderContent = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
`;

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; 
  margin-bottom: 16px;
  text-align: center;
`;

export const TitleLabel = styled.span`
  font-size: 20px; 
  font-weight: 700;
  color: #000;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const InfoText = styled.span`
  font-size: 18px; 
  color: #222;
  word-break: break-word;
  text-align: center; 
`;

export const LogHMLT = styled.div`
  font-size: 14px;
  color: #222;

  a {
    color: #007bff;
    text-decoration: underline;
  }
`;

export const ButtonMini = styled.button<{ btStyle?: 'dark' }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background: ${({ btStyle }) => (btStyle === 'dark' ? '#333' : '#ddd')};
  color: #fff;

  &:hover {
    opacity: 0.85;
  }
`;

export const IconSetting = styled(Mail)`
  font-size: 20px;
`;

export const IconArrowLeft = styled(ArrowLeftIcon)`
  font-size: 16px;
`;

export const LoadingPage = styled.div`
  margin-left: 10px;
  width: 14px;
  height: 14px;
  border: 2px solid #ccc;
  border-top: 2px solid #333;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;